import axios from "axios";
import configuration from "@/utils/configuration";

export const reserveService = {
  fetchReserveList(params) {
    return axios.get(`${configuration.backUrl}/reserve`, {
      withCredentials: true,
      params,
    });
  },
  fetchReserveDetail(reserveId) {
    return axios.get(`${configuration.backUrl}/reserve/search`, {
      withCredentials: true,
      params:{reserve_id:reserveId}
    });
  },
  patchReserveStatus(param) {
    return axios.patch(`${configuration.backUrl}/reserve/update-status`, null, {
      withCredentials: true,
      params: param,
    });
  },
  // ** Multiple user    
  confirmResrve(params) {
    return axios.patch(
      `${configuration.backUrl}/reserve/confirm`,null,{
        withCredentials: true,
        params: params
    });
  },
  fetchResrveExportOption() {
    return axios.get(`${configuration.backUrl}/reserve/export/option`, {
      withCredentials: true,
    });
  },
  fetchResrveExportFile(params) {
    return axios.get(`${configuration.backUrl}/reserve/export`,{
      withCredentials: true,
      responseType: "blob",
      params:params,
    });
  },
};
